import React from "react";
import { connect } from "react-redux";
import queryString from "query-string";

import "./SeasonPassPersonalInfo.sass";

import { editMembeshipCardInfo, getMemberCards } from "../../../store/actions/memberActions";

import 'react-phone-input-2/lib/style.css';

export const SeasonPassPersonalInfo = ({ dispatch, membershipList, getMemberCards, editMembeshipCardInfo, ...params }) => {

  const token = queryString.parse(params.location.search).token;

  window.location.href = window.location.origin + `/member/${token}/info` + window.location.search;

  return <></>;
};

const mapStateToProps = ({ member }) => ({
  membershipList: member.membershipList,
});
const mapDispatchToProps = (dispatch) => ({
  getMemberCards: (accessToken, eventId) =>
    dispatch(getMemberCards(accessToken, eventId)),
  editMembeshipCardInfo: (accessToken, ticket) =>
    dispatch(editMembeshipCardInfo(accessToken, ticket)),
  dispatch: (foo) => dispatch(foo),
});

export default connect(mapStateToProps, mapDispatchToProps)(SeasonPassPersonalInfo);